export default __webpack_public_path__ + "static/media/b8.fbd48c52.png";